@if (navView; as view) {
  <nav class="stage-nav" aria-label="Calculator progress">
    <p class="visually-hidden" aria-live="polite" aria-atomic="true">{{ view.statusAnnouncement }}</p>

    <ol class="stage-strip">
      @for (item of view.stripItems; track item.id; let last = $last) {
        <li
          class="stage-card"
          [class.stage-card--current]="item.status === 'current'"
          [class.stage-card--complete]="item.status === 'complete'"
          [class.stage-card--incomplete]="item.status === 'incomplete'"
        >
          <a
            class="stage-card__link"
            [routerLink]="itemLink(item)"
            [attr.aria-current]="item.status === 'current' ? 'step' : null"
            [attr.aria-label]="item.ariaLabel"
          >
            <span class="stage-card__icon" aria-hidden="true">
              @switch (item.icon) {
                @case ('student') {
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3 2 8.5 12 14l10-5.5L12 3Z"/>
                    <path d="M6 11.2v4.3c0 .6 2.7 2.5 6 2.5s6-1.9 6-2.5v-4.3"/>
                  </svg>
                }
                @case ('household') {
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z"/>
                  </svg>
                }
                @case ('finances') {
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="6" width="18" height="13" rx="2"/>
                    <path d="M3 10h18"/>
                    <path d="M8 14h3"/>
                  </svg>
                }
                @case ('results') {
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 11.5 11 13.5 15.5 9"/>
                    <circle cx="12" cy="12" r="9"/>
                  </svg>
                }
              }
            </span>
            <span class="stage-card__text">
              <span class="stage-card__title">{{ item.label }}</span>
              <span class="stage-card__subtitle">{{ item.subtitle }}</span>
            </span>
            @if (!last) {
              <span class="stage-card__chevron" aria-hidden="true">
                <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 3.5 10.5 8 6 12.5"/>
                </svg>
              </span>
            }
          </a>
        </li>
      }
    </ol>

    @if (view.financeSubItems.length) {
      <nav class="finance-substrip" aria-label="Finances sections">
        <ul class="finance-substrip__list">
          @for (sub of view.financeSubItems; track sub.id) {
            <li
              class="finance-substrip__item"
              [class.finance-substrip__item--current]="sub.status === 'current'"
              [class.finance-substrip__item--complete]="sub.status === 'complete'"
              [class.finance-substrip__item--incomplete]="sub.status === 'incomplete'"
            >
              <a
                class="finance-substrip__link"
                [routerLink]="itemLink(sub)"
                [attr.aria-current]="sub.status === 'current' ? 'step' : null"
                [attr.aria-label]="sub.ariaLabel"
              >
                <span class="finance-substrip__label">{{ sub.label }}</span>
                <span class="finance-substrip__meta">{{ sub.subtitle }}</span>
              </a>
            </li>
          }
        </ul>
      </nav>
    }
  </nav>
}
